import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Drawer,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React, { useState } from "react";
import Image from "../Image";
export default function TopBar({showMarquee}) {
  const [showSolutions, setShowSolutions] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const isMobile = useMediaQuery("(max-width:576px)");

  const buttonList = [
    { name: "Products", link: "https://www.kfintech.com/products/" },
    { name: "Information Center", link: "https://mfs.kfintech.com/mfs/Generalpages/Download%20Forms.aspx?frm=iC" },
    { name: "About Us", link: "https://www.kfintech.com/about-us/" },
    { name: "Careers", link: "https://careers.kfintech.com/" },
    { name: "Contact Us", link: "https://www.kfintech.com/contact-us/" },
  ];

  const allButtons = (
    <>
      <button
        className="text-white border-0 rounded my-0 solution_btn "
        style={{ backgroundColor: "black", color: "white" }}
        onClick={() => setShowSolutions((show) => !show)}
      >
        Solutions
        <Image
          src="/images/down-arrow-white.svg"
          className="solutions_drp_icon"
        />
      </button>

      {buttonList.map((b) => (
        <a
          className="text-white border-0  my-2 top_bar_link_list"
          style={{
            backgroundColor: "black",
            color: "white",
            fontWeight: "400",
          }}
          href={b.link}
          key={b.name}
        >
          {b.name}
        </a>
      ))}
    </>
  );

  return (
    <div>
    <div
        className={`d-flex flex-column overflow-hidden ${!showMarquee ? 'position-fixed' : ''}`}
        style={{
        top: "0",
        left: "0",
        width: "100%",
        backgroundColor: "black",
        // zIndex: 2000,
      }}
    >
      <div className={` d-flex shadow p-3 `}>
        <div
          className="max-width d-flex top_bar_sec"
          // style={{ height: "120px" }}
        >
          <div className=" mr-auto kfin_logo">
            <a href="">
              <Image src="/images/kfintech-white-tagline.svg" />
            </a>
          </div>
          {/* <p className="display-4 mr-auto kfin_logo">KFINTECH</p> */}

          <div className="d-none d-sm-flex top_bar_list">{allButtons}</div>

          <div className="d-block d-sm-none text-white ">
            {/* <p className="text-white">Menu</p> */}
            <button
              className="text-white border-0 rounded mobile_menu_icon"
              onClick={() => {
                setShowMenu((show) => !show);
                setShowSolutions(false);
              }}
            >
              <Image src="/images/hamburger.svg" className="menu_icon" />
            </button>
          </div>

          {/* {!isMobile &&  */}
          <Drawer
            open={showSolutions}
            onClose={() => setShowSolutions(false)}
            anchor={`top`}
            PaperProps={{
              style: { backgroundColor: "black" },
            }}
            BackdropProps={{
              style: { opacity: "0.2" },
            }}
          >
            {solutionsDropdownContent}
          </Drawer>
          {/* } */}
        </div>
      </div>

      {isMobile && (
        <ExpandSection expanded={showMenu}>
          <div className="d-flex flex-column">{allButtons}</div>
        </ExpandSection>
      )}

      {/* {
                    !!isMobile &&
                    <ExpandSection
                        expanded={showSolutions}
                    >
                        <div className="d-flex flex-column">
                        {solutionsDropdownContent}
                        </div>
                            
                    </ExpandSection>

                } */}
    </div>
    {
      showMarquee && (
        <div style={{ color: "red", padding: "10px",fontSize:20 }}>
        <marquee>The site will experience downtime on 26th January 2025 (Sunday) between 9AM to 12PM for maintenance activities.</marquee>
      </div>
      )
    }   
          </div>
  );
}

function ExpandSection({ expanded, children, ...props }) {
  return (
    <Accordion expanded={expanded}>
      <AccordionSummary
        expandIcon={() => <p className="bg-danger p-3 rounded">v</p>}
        // expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        style={{
          height: "0",
          margin: "0",
          padding: "0",
          minHeight: "0px",
        }}
      ></AccordionSummary>

      <AccordionDetails style={{ backgroundColor: "black" }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}

const solutionsDropdownContent = (
  <div
    className="  menu_drp"
    style={{
      // marginTop: "200px",
      backgroundColor: "black",
    }}
  >
    <div className="solutions_menu_droupdown">
      <div className="max-width row">
        <div className="col-sm-12 col-md-3">
          <div className="sub-menu-left">
            <h3>Our Solutions</h3>
            <p>
              Our services and solutions provide trust through assurance and
              help clients transform, grow and operate.
            </p>
            <Image src="/images/our_solutions_drop-down.svg" alt="icon" />
          </div>
        </div>
        <div className="col-sm-12 col-md-9 row">
          <ul>
            <li>
              <a href="https://mfs.kfintech.com/mfs/" target="_blank">
                <div className="sub-menu-icon">
                  <Image src="/images/header-mfs.svg" alt="icon" />
                </div>
                <div className="sub-menu-text">
                  <h5>Mutual Fund Solutions</h5>
                  <p>Ensuring ease of Investors across platforms</p>
                </div>
              </a>
            </li>
            <li>
              <a
                href="https://globalbusinessservices.kfintech.com/"
                target="_blank"
              >
                <div className="sub-menu-icon">
                  <Image src="/images/header-gbs.svg" alt="icon" />
                </div>
                <div className="sub-menu-text">
                  <h5>Global Business Solutions</h5>
                  <p>Efficient &amp; Effective optimization of resources</p>
                </div>
              </a>
            </li>
            <li>
              <a href="https://ris.kfintech.com/" target="_blank">
                <div className="sub-menu-icon">
                  <Image src="/images/header-cr.svg" alt="icon" />
                </div>
                <div className="sub-menu-text">
                  <h5>Corporate Registry</h5>
                  <p>Curating Innovative and tech driven services</p>
                </div>
              </a>
            </li>
            <li>
              <a
                href="https://www.kfintech.com/private-wealth-management/"
                target="_blank"
              >
                <div className="sub-menu-icon">
                  <Image src="/images/header-pwm.svg" alt="icon" />
                </div>
                <div className="sub-menu-text">
                  <h5>Private Wealth Management</h5>
                  <p>Perfect solution gateway for portfolio Information</p>
                </div>
              </a>
            </li>
            <li>
              <a href="https://enps.kfintech.com/" target="_blank">
                <div className="sub-menu-icon">
                  <Image src="/images/header-nps.svg" alt="icon" />
                </div>
                <div className="sub-menu-text">
                  <h5>National Pension system</h5>
                  <p>Smartly segregating savings and spending</p>
                </div>
              </a>
            </li>
            <li>
              <a
                href="https://www.kfintech.com/alternate-investment-fund/"
                target="_blank"
              >
                <div className="sub-menu-icon">
                  <Image src="/images/header-alter.svg" alt="icon" />
                </div>
                <div className="sub-menu-text">
                  <h5>Alternatives</h5>
                  <p>
                    One place for End-to-End Financial management solutions.
                  </p>
                </div>
              </a>
            </li>
            <li>
              <a href="https://www.kfintech.com/gfs-malaysia/" target="_blank">
                <div className="sub-menu-icon">
                  <Image src="/images/header-gfs.svg" alt="icon" />
                </div>
                <div className="sub-menu-text">
                  <h5>Global Fund Solutions</h5>
                  <p>Serving world class services across schemes</p>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    {/* <p className="display-4 text-white">
    Solutions placeholder
</p>

<div className="text-white">
    <p className="text-white">
        Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Hic aspernatur vel quia?
    </p>
</div> */}
  </div>
);
